const BRIDGE_BASE_URL = '/apps/apibridge/integration/path/';

const HC_API = {
    GENERATE_OTP: "/apps/holly-account/otp/generate",
    VALIDATE_OTP: "/apps/holly-account/otp/validate",
    GET_STORES: "/apps/hollyconnect/bff/get-store-list",
    CHECK_PHONE: "/apps/holly-account/Customer/phone-check",
    GET_STORE: "/apps/hollyconnect/bff/get-store",
    GET_COUPON_DATA: "/apps/holly-account/Customer/customer-discounts",
    SEND_CONTACT_FORM: BRIDGE_BASE_URL + "cmd91i4o20003flawbw9ugpfz",
    CHECK_CUSTOMER_STATE: "/apps/holly-account/Shopify/check-customer-status",
    SEND_MAIL_ACTIVATION: "/apps/holly-account/Shopify/send-mail-activation",
    SEND_RETURN_ITEMS: "/apps/hollyconnect/bff/refund",
    SEND_CANCEL_ITEMS: "/apps/hollyconnect/bff/cancel",
    GET_GUEST_ORDER: "/apps/hollyconnect/bff/get-order",
    GET_INSTALLMENT: "/apps/holly-payments/payment/installment-plans",
    SET_ADDRESS_METAFIELD: "/apps/holly-account/Address/upsert-address",
    DELETE_ADDRESS_METAFIELD: "/apps/holly-account/Address",
    GET_PICKUP_AVAILABILITY: BRIDGE_BASE_URL + 'cmk6s6yu90005z4jh1oc2pg0p'
};

const OTP_DATA = {
    DURATION_SEC: 300,
    LENGTH: 6,
    get ERROR_MESSAGE() {
        return window.otp?.locales?.ERROR_MESSAGE;
    },
    get EXPIRED_MESSAGE() {
        return window.otp?.locales?.EXPIRED_MESSAGE;
    },
    get WRONG_CODE_ERROR_MESSAGE() {
        return window.otp?.locales?.WRONG_CODE_ERROR_MESSAGE;
    },
    get ALREADY_USED_EMAIL_MESSAGE() {
        return window.otp?.locales?.ALREADY_USED_EMAIL_MESSAGE;
    },
    get RATE_LIMIT_ERROR_MESSAGE() {
        return window.otp?.locales?.RATE_LIMIT_ERROR_MESSAGE;
    },
    get PHONE_ALREADY_USED_MESSAGE() {
        return window.otp?.locales?.PHONE_ALREADY_USED_MESSAGE;
    },
};

const EMAIL_REGEX = /^(?!.*\.\.)[A-Za-z0-9_%+-](?:[A-Za-z0-9._%+-]*[A-Za-z0-9_%+-])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]{2,})+$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
const CUSTOMER_ENABLED_STATE = "ENABLED";


function getBodyFromApiBridgeResponse(response) {
    try {
        if(response && response.data){
            if(response.data.status === 200 && response.data.body) {
                const responseBody = response.data.body;
                const responseBodyJson = JSON.parse(responseBody);
                return responseBodyJson;
            } else if(response.data.status === 404) {
                return response.data;
            }
        }
        return null;
    } catch (error) {
        return null;
    }
}

